import React from 'react';
import { Link } from '@chakra-ui/react';
import benchatService from '../../../../../service/benchatService';
import { Line as LineIcon } from '../../../components/Icons';
import { useAppContext } from '../../../context/appContext';

const LineAccount = () => {
  const { lineLoginChannel } = useAppContext();
  const url = benchatService.getLineLoginUri(
    lineLoginChannel?.platformChannelId,
  );

  return (
    <Link href={url}>
      <LineIcon color="#06C755" boxSize="40px" />
    </Link>
  );
};

export default LineAccount;
